import './Footer.css';

import { Fade } from 'react-reveal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';

function FooterBar({}){
    return(
        <div className='Footer'>
            <div className='spikes'></div>
            <footer class="ContactInfo" id="ContactInfo">
                <Fade bottom distance="40%" duration={750}>
                <h2>✨ Let's connect! ✨</h2>
                </Fade>
                <Fade bottom distance="40%" duration={750}>
                <p className='mini-description'>I'm always open for new opportunities and projects! Let's get in touch and turn dreams into reality!</p>
                </Fade>
                <Fade bottom distance="40%" duration={750}>
                <ul className='socials'>
                    <li>
                        <a href='https://www.linkedin.com/in/sander-meijer-266641266/'><FontAwesomeIcon icon={faLinkedin} color='#fff'/></a>
                    </li>
                    <li>
                        <a href='https://github.com/SafeBuckleDev'><FontAwesomeIcon icon={faGithub} color='#fff'/></a>
                    </li>
                </ul>
                </Fade>
                <Fade bottom distance="40%" duration={750}>
                <p>📧 sandermeijer345@gmail.com</p>
                </Fade>
            </footer>
        </div>
    );
}

export default FooterBar;